module.exports = __webpack_public_path__ + "static/media/John C. Beckinridge - 1860.ff84aca7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/John C. Beckinridge - 1860.jpg
// module id = 517
// module chunks = 0